import script from "./RealTimePresentationView.vue?vue&type=script&setup=true&lang=js"
export * from "./RealTimePresentationView.vue?vue&type=script&setup=true&lang=js"

import "./RealTimePresentationView.vue?vue&type=style&index=0&id=a7a91056&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a7a91056"]])

export default __exports__